module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/index.js
 ** module id = 568
 ** module chunks = 1
 **/